import { useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";

const KEYS = ["A", "B", "C"];
const OPTIONS = [
    { value: "very_disappointed", key: "A" },
    { value: "somewhat_disappointed", key: "B" },
    { value: "not_disappointed", key: "C" },
];

export default function SurveyQuestionOne({ step, value, onChange, firstName }) {
    const { t } = useTranslation();

    const handleKey = useCallback((e) => {
        const idx = KEYS.indexOf(e.key.toUpperCase());
        if (idx !== -1) onChange(OPTIONS[idx].value);
    }, [onChange]);

    useEffect(() => {
        window.addEventListener("keydown", handleKey);
        return () => window.removeEventListener("keydown", handleKey);
    }, [handleKey]);

    return (
        <div>
            <p className="text-violet-400 font-mono text-sm mb-1">
                <span className="font-bold">{step}</span>
                <span className="text-white/30 mx-2">&rarr;</span>
                <span className="text-white/30">{step} / 4</span>
            </p>
            <h2 className="text-2xl sm:text-3xl font-bold text-white leading-tight mb-8">
                {t("survey.q1", { firstName: firstName || t("survey.defaultName") })}
            </h2>
            <div className="space-y-3">
                {OPTIONS.map((opt) => (
                    <button key={opt.value} onClick={() => onChange(opt.value)}
                        className={`group w-full text-left px-5 py-4 rounded-lg border transition-all duration-150 ease-out flex items-center gap-4 ${
                            value === opt.value
                                ? "border-violet-500 bg-violet-500/10"
                                : "border-white/10 bg-white/[0.03] hover:border-white/25 hover:bg-white/[0.06]"
                        }`}
                        style={{ transform: "scale(1)", transition: "transform 160ms cubic-bezier(0.23,1,0.32,1)" }}
                        onMouseDown={(e) => { e.currentTarget.style.transform = "scale(0.98)"; }}
                        onMouseUp={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
                        onMouseLeave={(e) => { e.currentTarget.style.transform = "scale(1)"; }}>
                        <span className={`flex-shrink-0 w-7 h-7 rounded text-xs font-bold flex items-center justify-center border transition-colors ${
                            value === opt.value
                                ? "border-violet-400 bg-violet-500/20 text-violet-300"
                                : "border-white/20 text-white/40 group-hover:border-white/40 group-hover:text-white/60"
                        }`}>{opt.key}</span>
                        <span className={`text-base font-medium transition-colors ${
                            value === opt.value ? "text-white" : "text-white/60 group-hover:text-white/80"
                        }`}>{t(`survey.${opt.value}`)}</span>
                    </button>
                ))}
            </div>
        </div>
    );
}
